<section *ngFor="let section of sections; index as i" class="story-section">
  <figure *ngIf="section.photo" class="story-photo" [class.story-photo-right]="i % 2 === 1">
    <app-fitness-media-image [mediaId]="section.photo.MediaId"
      [alt]="section.photo.AltText || section.photo.Caption || photoDescription"
      [width]="760" maxWidth="100%" maxHeight="440px"></app-fitness-media-image>
    <figcaption *ngIf="section.photo.Caption">{{ section.photo.Caption }}</figcaption>
  </figure>
  <!-- Angular also sanitizes each rendered fragment; no trusted-HTML bypass. -->
  <div class="recipient-rich-text" [innerHTML]="section.html"></div>
</section>
